<template>
    <div class="text-center">
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-badge
                    class="mx-3"
                    offset-x="15"
                    offset-y="15"
                    color="error"
                    :value="showNotific"
                >
                    <v-btn
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        small
                        dark
                        fab
                        @click="showNotific = false"
                    >
                        <v-icon>mdi-bell-outline</v-icon>
                    </v-btn>
                </v-badge>
            </template>
            <v-list dark class="mt-3" rounded style="min-width: 200px;">
                <v-list-item
                    v-for="(item, index) in notifications"
                    :key="index"
                >
                    <v-btn text small>{{ item.title }}</v-btn>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "notification-popup",
    data() {
        return {
            notifications: [
            ],
            showNotific: false
        }
    },
    mounted() {
        let notificationTargetId = this.$store.state.notificationTargetId;
        let url = `${this.$store.state.notificationUrl}/Notify?targetId=${notificationTargetId}`;
		let date = null;
        let source = new EventSource(`${url}`);
		let onSourceMessage = event => {
			let notifications = JSON.parse(event.data).Notifications;
			if (notifications) {
                notifications = notifications.reverse();
                for (let i = 0; i < notifications.length; i++) {
                    const item = notifications[i];
                    this.addNotification(item.Text);
                }
				date = new Date(Math.max(...notifications.map(n => new Date(n.CreatedAt))));
			}
        };
		let onSourceError = event => {
			if (date) {
				source.close();
				source = new EventSource(`${url}&date=${date.toISOString()}`);
				source.onmessage = onSourceMessage;
				source.onerror = onSourceError;
			}
        };
        source.onmessage = onSourceMessage;
        source.onerror = onSourceError;
    },
    methods: {
        addNotification(text) {
            this.notifications.unshift({ title: text })
            this.showNotific = true
        }
    }
}
</script>

<style scoped>

</style>
